<template>
  <v-dialog
      v-model="showForm"
      max-width="400px"
      transition="dialog-top-transition"
      persistent
  >
    <v-card>
      <v-toolbar fixed dark color="primary">
        <v-toolbar-title>
          <h4 class="title">{{title}}</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            dark
            @click="closed"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form>
        <v-card-text>
          <div class="md-layout">
            <div >
              <v-text-field
                  v-model="locacion.nombre"
                  label="Nombre"
              />
              <v-text-field
                  v-model="locacion.codigo"
                  label="Codigo"
              />

              <v-select
                  v-model="empresa"
                  :items="empresas"
                  item-text="nombre"
                  item-value="id"
                  label="Selecciona la Empresa"
                  chips
                  hint="Empresa"
                  persistent-hint
              ></v-select>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="terciary" dark @click="closed">
            Cancelar
          </v-btn>
          <v-btn v-if="title==='Actualizar Locacion'" color="secondary" @click="update" :loading="loading">
            Actualizar
          </v-btn>
          <v-btn v-else color="secondary" @click="create" :loading="loading">
            Crear
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "LocacionForm",
  props: {
    title: String,
    locacion: {},
    showForm: {
      type: Boolean,
      default: false,
    },
  },
  data: ()=>({
    loading: false,
    empresa: {},
    menu1: false,
  }),
  computed: {
    ...mapGetters(['empresas']),
  },
  mounted() {
    this.empresa = this.locacion.empresa ? this.locacion.empresa.id : null ;
  },
  methods: {
    async create() {
      this.loading= true;
      this.locacion.empresa = this.empresa;
      await this.$store.dispatch('createLocacion', this.locacion);
      this.loading= false;
      this.closed();
    },
    async update() {
      this.loading= true;
      this.locacion.empresa = this.empresa;
      await this.$store.dispatch('updateLocacion', this.locacion);
      this.loading= false;
      this.closed();
    },
    closed() {
      this.$emit('close');
    },
  },
}
</script>

<style scoped>

</style>
